module.exports = __webpack_public_path__ + "static/media/explorador_p.1c43fa1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/explorador_p.png
// module id = 1176
// module chunks = 0